import * as React from 'react';

export default ({thumbnailUrl}: ThumbnailProps) => (
   <div className="media-thumbnail">
      {thumbnailUrl && <img src={thumbnailUrl}/>}
   </div>
);

interface ThumbnailProps {
   thumbnailUrl: string;
}
